// src/main.ts
import '@shoelace-style/shoelace/dist/themes/light.css';
import { completeLogin, onAuthEvents } from './auth';

// Setup event handlers (logs in console)
onAuthEvents();

// Handle redirect callback
if (window.location.pathname.endsWith('/callback')) {
  // Complete the code exchange, then clean up the URL
  await completeLogin();
  history.replaceState({}, '', '/');
}

